import ProviderRatingBig from './ProviderRatingBig';

export default ProviderRatingBig;
